import { useEffect } from "react";
import { FlexGrid, Button, Typography, useDialog, useThemeProvider, Card, Skeleton, Separator } from '@albo-ui/core'
import { CouponsReportProps, CouponsProps } from "./types";
import { useCouponsTable } from "./hooks/useCouponsTable";
import { useCouponsUpdate } from "./hooks/useCouponsUpdate";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { paginationComponentOptions } from "../../../util/i18n-es";
import { Search, LocalActivity } from '@mui/icons-material';
import { IconButton, TextField } from '@mui/material';
import { SendCoupons } from "../../modals/send-coupons/SendCoupons";

export const CouponsReport = ({ changeAlert, changeLoader }: CouponsReportProps) => {
    
    const { theme } = useThemeProvider();
    const { columns, data, loading: loadingTable, search, disabledSearch, onReasign, getData, onHandleChange, onHandleSearch } = useCouponsTable(changeAlert)
    const { loading: loadingUpdate, partners, sendCoupons, onGetCatalogPartner} = useCouponsUpdate(changeAlert)
    const dialogProps = useDialog()

    const onSendCoupons = async (data: CouponsProps) => {
        dialogProps.onClose()
        sendCoupons(data)
    }
    const onCloseDialogCoupons = () => {
        dialogProps.onClose()
    }
    const onOpenDialogCoupons = () => {
        dialogProps.openDialog()
    }

    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])
    useEffect(() => {
        getData()
        onGetCatalogPartner()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    return (
        <Card padding={5} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }}> 
            <FlexGrid container fullWidth justify="space-between" style={{ display: "flex", marginBottom: 25 }}>
                <FlexGrid item>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <LocalActivity sx={{ marginRight: 1 }}/> Administración de Cupones
					</Typography>
                </FlexGrid>
                <FlexGrid item container spacing={2} style={{width: "30%", justifyContent: 'end'}}>
                    <Button buttonType='secondary' size='normal' onClick={onOpenDialogCoupons}>Cargar códigos</Button>
                    {data.length > 0 && <Button buttonType='primary' size='normal' onClick={onReasign.bind(this, null, search)}>Reasignar todo</Button>}
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: "50%", marginBottom: 25}}>
                <FlexGrid item fullWidth>
                    <TextField label={'Campaña'} value={search.campaing_uuid} onPaste={onHandleChange.bind(this, 'campaing_uuid')} onChange={onHandleChange.bind(this, 'campaing_uuid')} size='small' fullWidth color='secondary'/>
                </FlexGrid>
                <FlexGrid item fullWidth>
                    <TextField label={'Partner'} value={search.partner_uuid} onPaste={onHandleChange.bind(this, 'partner_uuid')} onChange={onHandleChange.bind(this, 'partner_uuid')} size='small' fullWidth color='secondary'/>
                </FlexGrid>
                <IconButton disabled={disabledSearch} onClick={onHandleSearch.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '6px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: disabledSearch? '#ccc' : '#8bc179' }}/></IconButton>
            </FlexGrid>

            { data.length === 0 && <Separator orientation="horizontal" style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            paginationComponentOptions={paginationComponentOptions}
                        />
                }
            </FlexGrid>
            <SendCoupons onClose={onCloseDialogCoupons} open={dialogProps.open} onConfirm={onSendCoupons.bind(this)} title={"Carga de cupones"} changeAlert={changeAlert} partners={partners}/>
        </Card>
    )
}

